"use strict";

var _preact = require("preact");
function GridListItem(props) {
  var className = props.className,
    isDisabled = props.isDisabled,
    restrictionReason = props.restrictionReason,
    isChecked = props.isChecked,
    title = props.title,
    itemIconEl = props.itemIconEl,
    showTitles = props.showTitles,
    toggleCheckbox = props.toggleCheckbox,
    recordShiftKeyPress = props.recordShiftKeyPress,
    id = props.id,
    children = props.children;
  return (0, _preact.h)("li", {
    className: className,
    title: isDisabled ? restrictionReason : null
  }, (0, _preact.h)("input", {
    type: "checkbox",
    className: "uppy-u-reset uppy-ProviderBrowserItem-checkbox ".concat(isChecked ? 'uppy-ProviderBrowserItem-checkbox--is-checked' : '', " uppy-ProviderBrowserItem-checkbox--grid"),
    onChange: toggleCheckbox,
    onKeyDown: recordShiftKeyPress,
    name: "listitem",
    id: id,
    checked: isChecked,
    disabled: isDisabled,
    "data-uppy-super-focusable": true
  }), (0, _preact.h)("label", {
    htmlFor: id,
    "aria-label": title,
    className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
  }, (0, _preact.h)("span", {
    className: "uppy-ProviderBrowserItem-inner-relative"
  }, itemIconEl, showTitles && title, children)));
}
module.exports = GridListItem;